import { Box, TextField } from "@mui/material";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { useState } from "react";

export const StreamVendorsCreate = () => {
    const {
        saveButtonProps,
        refineCore: { formLoading },
        register,
        formState: { errors },
    } = useForm();

    const [config, setConfig] = useState("");
    const [pusherParams, setPusherParams] = useState("");
    const [playerParams, setPlayerParams] = useState("");

    const testFun = (value: any, name: string) => {
        try {
            JSON.parse(value);
            return true;
          } catch (err) {
            window.alert(`The new ${name} value is not a valid json string, please check and pay attention to use double quotes!`);
            return;
          }
    }
    return (
        <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <TextField
                    {...register("name", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.name}
                    helperText={(errors as any)?.name?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="Name"
                    name="name"
                />
                <TextField
                    {...register("showName", {
                        required: "This field is required",
                    })}
                    error={!!(errors as any)?.showName}
                    helperText={(errors as any)?.showName?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="ShowName"
                    name="showName"
                />
                <TextField
                    {...register("config", {
                        required: "This field is required",
                        validate: () => {
                            return testFun(config, "config") === true;
                        }
                    })}
                    error={!!(errors as any)?.config}
                    helperText={(errors as any)?.config?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    label="Config"
                    name="config"
                    value={config}
                    onChange={(e) => setConfig(e.target.value)}
                />
                <TextField
                    {...register("pusherParams", {
                        required: "This field is required",
                        validate: () => {
                            return testFun(pusherParams, "pusherParams") === true;
                        }
                    })}
                    error={!!(errors as any)?.pusherParams}
                    helperText={(errors as any)?.pusherParams?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="PusherParams"
                    name="pusherParams"
                    value={pusherParams}
                    onChange={(e) => setPusherParams(e.target.value)}
                />
                <TextField
                    {...register("playerParams", {
                        required: "This field is required",
                        validate: () => {
                            return testFun(playerParams, "playerParams") === true;
                        }
                    })}
                    error={!!(errors as any)?.playerParams}
                    helperText={(errors as any)?.playerParams?.message}
                    margin="normal"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    label="PlayerParams"
                    name="playerParams"
                    value={playerParams}
                    onChange={(e) => setPlayerParams(e.target.value)}
                />
            </Box>
        </Create>
    );
};